/*
 *
 * App reducer
 *
 */

import {
  SET_AUTH_TOKEN,
  SET_USER,
  FETCH_SESSION,
  SESSION_LOAD_FAILED,
} from './constants';

import {
  PUT_ACCOUNT_SUCCESS
} from 'containers/AccountPage/constants'

const initialState = {
  user: {
    authToken: '',
    company: null,
    enterprise_admins: null,
    id: null,
    if_lite_photographer: null,
    if_unlimitied_photographer: null,
    permission_role: "",
    name: '',
    email: '',
    role: '',
    unconfirmedEmail: null
  },
  // The session restore failed transiently and nothing else will retry it. The
  // token is still valid as far as we know, so the app stays authenticated —
  // which is exactly why this has to be recorded: a route that waits on the
  // session would otherwise wait forever.
  sessionLoadFailed: false,
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AUTH_TOKEN:
      return {
        ...state,
        user: {
          ...state.user,
          authToken: action.payload
        }
      };
    case SET_USER:
    case PUT_ACCOUNT_SUCCESS:
    case 'PLAN_SUBSCRIPTION_SUCCESS':
      return {
        ...state,
        sessionLoadFailed: false,
        user: {
          ...state.user,
          ...action.payload
        }
      };
    // Cleared when the retry is ISSUED, not when it succeeds — unlike the
    // lists' `listError`, where clearing on dispatch drops the page back
    // through a state that lies. Here the state underneath is the loader,
    // which is the honest answer while a request is genuinely in flight.
    case FETCH_SESSION:
      return {
        ...state,
        sessionLoadFailed: false,
      };
    case SESSION_LOAD_FAILED:
      return {
        ...state,
        sessionLoadFailed: true,
      };
    default:
      return state;
  }
}

export default appReducer;
